import './ProductSection.css';
import NavHeaders from '../../components/NavHeaders/NavHeaders';
import BackButton from '../../components/BackButton/BackButton';
import ProductDetails from '../../components/ProductDetails/ProductDetails';
import relatedProduct from '../../img/product-detail-related-product.svg';
import Footer from '../../components/Footer/Footer';
import { useParams, useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import modalCloseBtn from '../../img/modal-close-btn.svg';
import parse from 'html-react-parser';
import Swal from 'sweetalert2';

const ProductSection = () => {

    if (window.twttr) {
        window.twttr.widgets.load();
    }

    window.scrollTo(0, 0)
    const history = useHistory();
    const sessionId = localStorage.getItem("sessionId");
    const userId = localStorage.getItem("userId");
    const userFullName = localStorage.getItem("userFullName");
    const userAddress = localStorage.getItem("userAddress");
    const userEmailAddress = localStorage.getItem("userEmailAddress");
    const userMobilePhone = localStorage.getItem("userMobilePhone");

    const [productData, setProductData] = useState({});
    const [userIdData, setUserIdData] = useState(userId);
    const [userFullNameData, setUserFullNameData] = useState(userFullName);
    const [userAddressData, setUserAddressData] = useState(userAddress);
    const [userEmailAddressData, setUserEmailAddressData] = useState(userEmailAddress);
    const [userMobilePhoneData, setUserMobilePhoneData] = useState(userMobilePhone);
    const [methodInputValue, setMethodInputValue] = useState("Markopedia E-Money");
    const [showModal, setShowModal] = useState(false);
    const [adsList, setAdsList] = useState([])
    const [adsLoading, setAdsLoading] = useState(false);
    const [urlStatus, setUrlStatus] = useState("");
    const [urlRedirectToPaymentGateway, setUrlRedirectToPaymentGateway] = useState("");

    const { id } = useParams();

    const getProductDetails = async () => {
        const productDetails = await fetch("https://backend-markopedia.herokuapp.com/api/product/products/" + id, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + sessionId
            }
        })
            .then(res => res.json());

        setProductData(productDetails.data);

    }

    const handleNameChange = (e) => {
        setUserFullNameData(e.target.value)
    }

    const handleEmailChange = (e) => {
        setUserEmailAddressData(e.target.value)
    }

    const handlePhoneNumberChange = (e) => {
        setUserMobilePhoneData(e.target.value)
    }

    const handleAddressChange = (e) => {
        setUserAddressData(e.target.value)
    }

    const handleMethodInputValue = (e) => {
        setMethodInputValue(e.target.value)
    }

    const showPaymentModal = () => {
        if (sessionId) {
            setShowModal(true);
        } else {
            Swal.fire({
                text: 'Mohon login dahulu sebelum membeli barang.',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#0476D0',
                confirmButtonText: 'OK'
            }).then((result) => {
                if (result.isConfirmed) {
                    history.push("/login")
                }
            })
        }
    }

    const getAdWebAds = async () => {
        const adsResponse = await fetch("https://adweb-api.herokuapp.com/embed-code/twitter/pub1-1621052754260/300/3", {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        })
            .then(res => res.json())
            .then((data) => {
                console.log(data);
                setAdsList(data.data);
                setAdsLoading(true);
            })
    }

    const getUrlFromPaymentGateway = async () => {
        const response = await fetch("https://payment-gateway-iai.herokuapp.com/api/transaction", {
            method: "POST",
            body: JSON.stringify({
                email_buyer: "Arnan@gmail.com",
                email_seller: "dessy.r@gmail.com",
                buyer_name: "RevinGanteng",
                total_payment: productData.price
            })
        }).then(res => res.json())
            .then(data => {
                setUrlStatus(data.url2)
                setUrlRedirectToPaymentGateway(data.url1);
                console.log(data.url2, data.url1);
                fetch("https://backend-markopedia.herokuapp.com/api/order", {
                    method: "POST",
                    body: JSON.stringify({
                        productName: productData.productName,
                        price: productData.price,
                        statusUrl: data.url2
                    }),
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + sessionId
                    }
                }).then(res => res.json())
                    .then(res => {
                        console.log(res)
                        Swal.fire({
                            text: 'Pembayaran akan dilanjutkan ke payment gateway',
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonColor: '#0476D0',
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.open("https://payment-gateway-iai.herokuapp.com/", "_blank");
                            }
                        })
                    })
            });
    }

    const handlePaymentClick = () => {
        //     console.log(
        //         userFullNameData,
        // userAddressData,
        // userEmailAddressData,
        // userMobilePhoneData,
        // methodInputValue
        //     )
        getUrlFromPaymentGateway();

    }

    useEffect(() => {
        getProductDetails();
        getAdWebAds();
    }, [])


    return (
        <>
            <NavHeaders />
            <div className="productsection-backbutton-wrapper">
                <BackButton text="Back" goBack="back" />
            </div>
            <div className="productdetail-relatedproduct-wrapper">
                <ProductDetails onClick={showPaymentModal} data={productData} />
                {
                    adsLoading ?
                        <div className="relatedproduct-wrapper">
                            {
                                adsList.map(x => {
                                    return parse(x.embed_code)
                                })
                            }
                        </div>
                        :
                        <div className="productsection-loader-wrapper">
                            <div className="productsection-loader"></div>
                        </div>
                }

            </div>
            {
                showModal ?
                    <div className="payment-modal-overlay">
                        <div className="payment-modal-content">
                            <div onClick={() => setShowModal(false)} id="payment-modal-close-btn">
                                <img src={modalCloseBtn}></img>
                            </div>
                            <div className="payment-modal-header">
                                <h1>Pembayaran</h1>
                            </div>
                            <div className="payment-modal-body">
                                <div className="payment-modal-body-left">
                                    <input onChange={handleNameChange} type="text" placeholder="Full Name" defaultValue={userFullNameData}></input>
                                    <input onChange={handleEmailChange} type="text" placeholder="Email Address" defaultValue={userEmailAddressData}></input>
                                    <select onChange={handleMethodInputValue} id="payment-method-input">
                                        <option value="Markopedia E-Money">Markopedia E-Money</option>
                                        <option value="Credit Card">Credit Card</option>
                                        <option value="Bank Transfer">Bank Transfer</option>
                                    </select>
                                </div>
                                <div className="payment-modal-body-right">
                                    <input onChange={handlePhoneNumberChange} type="text" placeholder="Phone Number" defaultValue={userMobilePhoneData}></input>
                                    <textarea onChange={handleAddressChange} type="text" placeholder="Address" defaultValue={userAddressData}></textarea>
                                </div>
                            </div>
                            <div className="payment-modal-footer">
                                <button>
                                    <h2 onClick={handlePaymentClick}>Lanjutkan Pembayaran</h2>
                                </button>
                            </div>
                        </div>
                    </div>
                    :
                    null
            }
            <Footer />
        </>
    )
};

export default ProductSection;

